<template>
  <div class="protocol">
    <ucar-title>{{ title }}</ucar-title>
    <div class="protocol-body">
      <h2>用户服务协议</h2>
      <p>
        神州优车（福建）信息技术有限公司（以下称“我司”或“我们”）根据用户出行需求向乘客提供网约车服务，在您申请成为我司优驾（U+）司机之前，请您认真阅读本协议及附件，并确保充分理解本协议及附件中各条款，对于尤为重要的条款，我们已予以加粗，请您重点注意。一旦您点击同意本协议，即表示您已充分阅读并接受本协议及附件的全部内容，同意与我司订立本协议，并且同意我司按照本《用户服务协议》收集、使用您的信息。
      </p>
      <p>
        在成为优驾（U+）司机之前，您需要在“优驾（U+）”应用程序（以下简称“平台”）进行注册，本平台将通过手机验证码来识别您的注册指令。注册成功后，您需按照平台要求完善个人基础信息资料，并保证提供的资料真实、准确、完整、合法、有效。如您的注册资料有所变动，请您及时更新注册资料。
        <strong
          >您提交的信息，我们将按照法律法规要求保存，并采取各项安全保护措施，保障您的个人信息安全。</strong
        >
      </p>
      <h3>一、信息收集、使用、共享与保护</h3>
      <p>
        您同意我们采集、处理、分享、保护您的信息。请您仔细阅读以下内容，如有任何疑问，请随时联系我们。
      </p>
      <ul>
        <li>
          （一）收集您的信息的目的和方式
          <p>
            目的：为了符合法律法规的规定，以及按约定向您提供服务，您同意我们遵循合法、正当、必要的原则，按照如下方式收集您的信息：
          </p>
          <ol>
            <li>
              在您申请成为优驾（U+）司机过程中，您向我们提交的信息或新产生的信息，包含但不限于：姓名、性别、身份证号、住址、教育、就业；
            </li>
            <li>
              为了审核您是否符合优驾（U+）司机标准，收集您留存在本平台的身份信息及驾驶证件信息，例如：姓名、手机号、城市、身份证有效期、准驾车型、驾驶证初次领证日期、驾驶证有效期、驾驶证档案编号；
            </li>
            <li>
              您申请自带车辆加入优驾（U+）平台时，为了审核您是否符合优驾（U+）司机标准，您向我们提交的信息或新产生的信息，包含但不限于：车牌号、车型、车辆颜色、车架号、发动机号、车辆所有人的相关信息；
            </li>
            <li>
              为了审核您自带的车辆是否符合优驾（U+）车辆标准，收集您留存在本平台的车辆信息及行驶证证件信息，例如：车牌号、车型、车辆颜色、车架号、发动机号、车辆所有人、车辆注册日期、年检到期日；
            </li>
            <li>
              基于法律法规的要求、平台系统根据定位实现派单及提供其他位置相关服务，我们将收集您提供的手机位置信息。
            </li>
            <li>
              行程信息，基于法律法规要求以及保护您的人身财产安全、依照平台规则处理乘客纠纷之需要，我们将通过记录车辆行驶情况收集您的每个订单的出发地、目的地、行程轨迹、时长及里程数信息。我们收集上述信息，为了保证您及车辆财产安全，我们需要获取您所驾驶车辆的行程路线，如果您拒绝我们获取您的相关信息，可能导致我们无法获得您的实际行驶路线、无法更好地保护您及乘客的权益。
            </li>
            <li>
              订单信息及交易状态。基于法律法规要求以及保护您的人身财产安全、依照平台规则处理乘客纠纷之需要。我们将记录您的订单信息、交易状态、银行卡等信息。
            </li>
            <li>
              录像信息
              。您在申请成为优驾司机时，我们需要收集您的录像信息。一方面是为审核您的背景信息需要，完成我司平台的司机实名认证；另一方面是基于地方性法律法规的要求，在发生纠纷或安全事故时平台有依据进行核实并处理。
            </li>
            <li>
              为了使您能够正常使用平台应用软件的相应功能。我们会收集您的移动设备的系统版本等信息，包括设备型号、设备识别码、操作系统、系统版本，并完成我司平台应用软件与您的移动设备的功能性兼容。
            </li>
            <li>
              其他您在使用优驾（U+）平台时您自愿提供的信息，如可以通过“优驾开放平台”司机应用软件-“个人管理”页面输入紧急联系人姓名、紧急联系人电话，主要用于在紧急、突发情况下我司平台能够联系到您的家人/朋友，以保证您的行车安全。
            </li>
            <li>
              为了审核您是否符合优驾（U+）司机标准，在您同意授权神州优车（福建）信息技术有限公司及其关联方【神州闪贷（平潭）融资租赁有限公司等】向依法成立的征信机构或其他调查机构对您的背景信息进行全面核实后。我们将收集您的如下背景信息：包括但不限于身份、住址、教育、就业、工作表现、诉讼记录、信用记录、驾驶历史、犯罪记录以及其它不良记录。
            </li>
          </ol>
        </li>
        <li>
          （二）使用您的信息
          <p>
            为满足网约车服务及保护各方的合法权益，您同意我们将您的信息用于如下用途：
          </p>
          <ol>
            <li>优驾（U+）司机报名准入条件筛选、用户身份识别；</li>
            <li>为保护您的账户安全，对您的身份进行识别、验证；</li>
            <li>
              按照法律法规的规定，根据公安、检察院、法院、政府等机关要求进行使用；
            </li>
            <li>预防或阻止非法活动；</li>
            <li>为解决您与平台之间产生的违约纠纷或投诉处理；</li>
            <li>比较信息的准确性，与第三方进行验证、调查核实信息真实性；</li>
            <li>经您同意的其他用途。</li>
          </ol>
        </li>
        <li>
          <strong>（三）共享您的信息</strong>
          <p>
            <strong
              >我司对您的信息进行严格保密，不会因第三方的营销目的而披露您的任何信息，您同意我司在下列情况下将您的信息与第三方共享：</strong
            >
          </p>
          <ol>
            <li><strong>与关联公司间共享；</strong></li>
            <li><strong>为调查核实您的背景信息；</strong></li>
            <li>
              <strong>按照法律法规的规定，根据行政、司法等机关的要求；</strong>
            </li>
            <li><strong>事先获得您的授权同意的情形；</strong></li>
            <li>
              <strong
                >只有批露您的个人信息，才能使我们或我们的关联公司、合作公司提供您所要求的产品和服务；</strong
              >
            </li>
            <li>
              <strong>为维护我们及我们的关联公司、合作公司的合法权益；</strong>
            </li>
            <li>
              <strong
                >我们发现您违反了我们的服务条款或任何其他产品服务的使用规定；</strong
              >
            </li>
            <li><strong>只法律法规规定的其他情形。</strong></li>
          </ol>
        </li>
        <li>
          （四）如何保护您的信息
          <p>
            我们承诺对您的个人信息予以保密，为此我们设置了安全程序保护您的信息不会被未经授权的访问所窃取。
          </p>
          <p>
            我们建议您通过安全方式、使用复杂密码，协助我们保证您的账号安全。如您发现自己的个人信息泄密，尤其是您的账户或密码发生泄漏，请您立即与联系我们，以便我们采取相应措施。
          </p>
        </li>
      </ul>
      <h3>二、安全培训及考试</h3>
      <p>
        为维护和保障乘客和驾驶员的合法权益，提升平台中全体用户的满意程度，在身份安全验证通过后，您需要在平台报名网站上完成网约车相关知识学习并进行考试，考试通过后，您将有机会成为优驾（U+）司机。学习内容包含但不限于网约车相关法律法规、客户服务规范、安全运营等方面的知识。
      </p>
      <h3>三、免责声明</h3>
      <ul>
        <li>
          （一）您同意有下列情况之一的，我司或我司关联方不承担任何法律责任：
        </li>
        <ol>
          <li>
            由于您将用户密码告知他人或与他人共享注册帐户，而导致的任何个人资料泄露；
          </li>
          <li>
            任何由于黑客攻击、计算机病毒侵入或发作、政府管制等造成的暂时性关闭，使网络无法正常运行而造成的个人资料泄露、丢失、被盗用或被窜改；
          </li>
          <li>
            由于与本网站链接的其他网站所造成的个人资料泄露及由此导致的任何法律争议和后果；
          </li>
          <li>因不可抗力引起的任何后果。</li>
        </ol>
        <li>
          （二）您同意并知悉网约车平台所提供的功能受制于我国的交通法规和管理条例，若本平台的功能与上述规定发生冲突，应以有关规定为准。
        </li>
      </ul>
      <h3>四、协议变更、解除、终止和权利义务的转让</h3>
      <ul>
        <li>
          （一）协议变更
          <p>
            本协议内容包括本协议条款以及已经发布的及将来可能发布的与您有关的各项约定，该等约定均为本协议不可分割的一部分，与本协议具有同等法律效力，在本协议履行过程中，我司可根据情况对本协议进行修改。一旦本协议的内容发生变动，我司将通过“优驾（U+）”应用程序公布最新的协议，不再向您作个别通知。如果您不同意我司对本协议及有关约定所做的修改，您有权停止使用我司服务。如果您继续使用我司服务，则视为您接受我司对本协议及有关约定所做的修改，并应遵照修改后的协议执行。
          </p>
        </li>
        <li>
          （二）协议解除与终止
          <ol>
            <li>
              在您使用服务的过程中，如果有下列情形发生，我们可以单方面解除本协议：
              <ul>
                <li>1） 您的账户已注销；</li>
                <li>2） 您冒用他人名义、盗用他人账户使用服务；</li>
                <li>3） 您为非法目的使用服务的；</li>
                <li>4） 您从事任何可能侵害优驾平台系统、资料之行为；</li>
                <li>
                  <strong>5） 您违反本协议约定及与本协议相关法律法规；</strong>
                </li>
                <li>
                  <strong
                    >6）
                    除上述原因外，我们可以根据风险及自身业务运营情况需要终止向您提供某些服务，届时公司将公告或告知。</strong
                  >
                </li>
              </ul>
            </li>
          </ol>
        </li>
        <li>
          （三）权利义务的转让
          <p>
            我司可能会基于服务的需要，变更或增加履约主体，如您继续使用本平台的服务，将视为您同意变更后的主体或新增的主体作为与您履约的相对方。
          </p>
        </li>
      </ul>
      <h3>五、争议的解决</h3>
      <p>
        本协议的订立、效力、解释、履行及争议的解决均适用中华人民共和国法律。在协议履行期间，凡由本协议引起或与本协议有关的一切争议、纠纷，由福建省厦门市思明区人民法院管辖。
      </p>
      <h3>六、特别约定</h3>
      <p>本网约车服务平台的所有权、运营权归我司所有。</p>
      <p>
        <strong
          >附件一是优驾（U+）司机、优驾车辆及手机硬件准入标准，该标准是本协议不可分割的组成部分，您接受和同意本协议，也即接受并同意了附件一中的标准。</strong
        >
      </p>
      <h2>附件一</h2>
      <h3>优驾（U+）司机、优驾车辆及手机硬件准入标准</h3>
      <ul>
        <li>（一）成为优驾司机您需符合以下标准：</li>
        <ol>
          <li>
            实际驾龄三年以上，C1（含）以上驾照、且驾照类型满足所驾驶车型所需，熟悉您所在运营城市的道路，驾驶习惯良好；
          </li>
          <li>
            五官端正，身体健康，外露皮肤无明显疤痕、纹身，无怪异发型（颜色），无传染疾病；
          </li>
          <li>普通话标准，懂外语优先（简单会话即可）；</li>
          <li>
            年龄为：男25-55周岁、女
            25-50周岁，无犯罪记录、无吸毒记录、无饮酒后驾驶记录、最近连续 3
            个记分周期内没有记满 12
            分记录且三年之内无重大事故、无精神病史、无不良嗜好；
          </li>
          <li>
            无下列疾病：
            <ul>
              <li>1）器质性心脏病</li>
              <li>2）癫痫病</li>
              <li>3）美尼尔氏症</li>
              <li>4）眩晕症</li>
              <li>5）癔病</li>
              <li>6）震颤麻痹</li>
              <li>7）精神病</li>
              <li>8）痴呆以及影响肢体活动的神经系统疾病</li>
              <li>
                9）妨碍安全驾驶疾病及传染性疾病（如：肺结核、腮腺炎等通过空气、飞沫传播的传染病）
              </li>
              <li>
                10）吸食、注射毒品、长期服用依赖性精神药品成瘾尚未戒除的；
              </li>
            </ul>
          </li>
          <li>应取得法律法规或行业标准等文件规定的相应资质；</li>
          <li>
            不存在法律法规或行业标准等文件规定的不得、不宜从事网络预约汽车驾驶服务的其他情形。
          </li>
        </ol>
        <li>
          （二）您使用的车辆需满足以下标准：
          <ol>
            <li>行驶里程：10 万公里以内</li>
            <li>车龄：5 年以内（车龄起算点以车辆登记注册日期为准）</li>
            <li>车辆保险：交强险</li>
            <li>
              轿车要求为 4 门、准载 5 人三厢车；SUV车要求为 5
              门、5-7座；商务车要求为 5门、7 座
            </li>
            <li>
              平台车辆颜色：黑、白、灰、蓝、棕、红，颜色按照色系执行，例如：深灰、浅灰算灰色、金色算棕色
            </li>
            <li>车辆淘汰标准：车龄满 7 年或车辆行驶里程达到 60 万千米</li>
            <li>
              无重大交通事故，无泡水，车身干净无尘土，无损坏及明显划痕，车辆号牌清晰
            </li>
            <li>无改装，无喷涂装饰，无手台低音炮等</li>
            <li>灯光使用正常</li>
            <li>内饰干净整洁无破损无异味，座椅干净整洁无破损无陈旧褶皱</li>
            <li>仪表按键使用正常</li>
            <li>无广告贴、饰品、挂件等装饰物</li>
            <li>车内物品按规定位置摆放整齐</li>
            <li>车辆全车贴膜</li>
            <li>
              车辆证件配件齐全（包括交强险标志、绿色环保标志、车辆检验合格标志、行驶证、维修保养手册、工具包、灭火器、千斤顶、备胎、点烟器、脚垫）
            </li>
            <li>安装具有行驶记录功能的车辆卫星定位装置、应急报警装置</li>
            <li>应取得法律法规或行业标准等文件规定的相应资质</li>
            <li>
              如果法律法规或行业标准等文件另有其他规定，您使用的车辆应当同时满足上述文件其他规定的要求。
            </li>
          </ol>
        </li>
        <li>
          （三）您使用的移动设备需满足手机硬件准入标准：ANDROID 5.0 及以上或iOS
          11.0及以上版本。
        </li>
      </ul>
      <h2>附件二</h2>
      <h3>优驾（U+）司机落实新冠肺炎防控方案责任书</h3>
      <p>
        为进一步指导各地做好新型冠状病毒肺炎防控工作，国务院应对新型冠状病毒肺炎疫情联防联控机制综合组制定了新型冠状病毒肺炎防控方案（第九版）要求所有网约车从业人员需签署并遵守：
      </p>
      <h4>一、总体要求</h4>
      <p>
        坚持“预防为主、防治结合、依法科学、分级分类”的原则，坚持常态化精准防控和局部应急处置相结合，按照“及时发现、快速处置、精准管控、有效救治”的工作要求，坚决防范境外疫情输入和境内疫情反弹。坚持科学精准防控，落实“早预防、早发现、早报告、早隔离、早治疗”措施，进一步加强源头管控，坚持人、物、环境同防，加强重点时段、重点地区、重点人群疫情防控，提高监测预警灵敏性，及时发现散发病例和聚集性疫情，有力、有序、有效处置疫情，做到发现一起扑灭一起，以最短时间、最低代价将疫情控制在最小范围，切实维护人民群众生命安全和身体健康，最大限度统筹疫情防控和经济社会发展。
      </p>

      <h4>二、病原学和流行病学特征</h4>
      <p>
      新型冠状病毒（2019-nCoV，以下简称新冠病毒）属于β属冠状病毒，对紫外线和热敏感，乙醚、75%乙醇、含氯消毒剂、过氧乙酸和氯仿等脂溶剂均可有效灭活病毒。人群普遍易
      感。传染源主要是新冠肺炎确诊病例和无症状感染者；主要传播途径为经呼吸道飞沫和密切接触传播，在相对封闭的环境中经气溶胶传播，接触被病毒污染的物品后也可能造成感染。目前，奥密克戎变异株已成为我国境外输入和本土疫情的优势流行株，现有研究提示，奥密克戎变异株平均潜伏期缩短，多为2-4
      天，传播能力更强，传播速度更快，感染剂量更低，致病力减弱，具有更强的免疫逃逸能力，现有疫苗对预防该变异株所致的重症和死亡仍有效。
      </p>
      <h4>三、落实疫情防控手段：</h4>
      <ol>
        <li>
          遵守公民防疫基本行为准则：勤洗手、科学佩戴口罩、注意咳嗽礼仪、少聚集、勤通风、做好车内清洁消毒通风工作、养成健康生活方式。
        </li>
        <li>
          接种疫苗：要求所有从业人员需接种加强针疫苗，做到“应接尽接”，保护个人健康。
        </li>
        <li>
          核酸检测：所有从业人员应按照当地政府关于从业人员核酸检测要求，持要求期限内有效核酸阴性结果证明上岗。其中北京地区从业人员应按照北京市政府关于从业人员须持48小时内核酸阴性结果上线的要求（如政策调整需按实际规定时间）。
        </li>
        <li>
          监督乘客扫码：监督所有乘坐网约车乘客扫到访码，健康码必须为绿色！保证所有乘客均扫码，禁止截图等。
        </li>
        <li>
          配合流调：积极配合政府部门的流调工作，如有相关情况应立即上报社区，坚决配合政府的防疫要求：包括居家、定期核酸检测等。
        </li>
        <li>
          应急处理：如遇健康码出现黄码、红码或确认密接人员等，应立即采取措施，上报相关属地防疫部门、运输行业主管部门，做到立即处置、防止扩散！
        </li>
      </ol>
    </div>
  </div>
</template>

<style lang="stylus" scoped>
@import '../../styles/variable.styl';

.protocol {
  .protocol-body {
    padding: 0 30px 30px;
  }

  h2, h3, h4 {
    text-align: center;
    font-weight: bold;
  }

  h2 {
    font-size: $ucar_font_h4;
    margin: 60px auto;
  }

  h3 {
    font-size: $ucar_font_h5;
    margin: 40px;
  }

  p {
    font-size: $ucar_font_h6;
    margin-bottom: 40px;
    line-height: 1.5;
    text-indent: 2em;
  }

  ul, ol {
    li {
      font-size: $ucar_font_h6;
      color: $ucar_font_color;
      line-height: 2;
    }
  }

  ul {
    li {
      text-indent: 2em;
    }
  }

  ol {
    & > li {
      list-style: decimal inside;
    }
  }
}
</style>

<script>
export default {
  data() {
    return {
      title: '服务合作协议',
    }
  },
}
</script>
